
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.2388 5.33865C13.0156 5.22107 10.2984 7.59911 10.0082 10.7779C9.92252 11.7152 10.6154 12.5437 11.5552 12.6291C12.4795 12.7023 13.3248 12.0246 13.4115 11.0863C13.5361 9.71759 14.7039 8.67055 16.0998 8.74375C17.4244 8.79698 18.5611 9.95938 18.5822 11.2815C18.5978 12.2076 18.134 13.0484 17.341 13.5331C15.4269 14.6999 14.2835 16.1465 14.2835 18.296C14.2835 19.2365 15.0487 19.9996 15.9919 19.9996C16.935 19.9996 17.7002 19.2365 17.7002 18.296C17.7002 17.3432 18.2319 16.9825 19.1239 16.439C20.9323 15.3354 22.0345 13.3367 21.9989 11.2249C21.9478 8.10599 19.3641 5.46621 16.2388 5.33865Z","fill":"#10001F"}}),_c('path',{attrs:{"d":"M15.9998 26.6656C17.1043 26.6656 17.9996 25.7703 17.9996 24.6658C17.9996 23.5614 17.1043 22.666 15.9998 22.666C14.8953 22.666 14 23.5614 14 24.6658C14 25.7703 14.8953 26.6656 15.9998 26.6656Z","fill":"#10001F"}})])
          )
        }
      }
    